import React from 'react';
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';

const AiApprovalCard = ({ approval, onApprove, onDismiss, loading }) => {
  if (!approval) return null;

  return (
    <Box sx={{ px: 2, mb: 1.5 }}>
      <Card variant="outlined" sx={(theme) => ({ bgcolor: theme.palette.mode === 'dark' ? '#2d1f00' : '#fff8e1', borderColor: '#f9a825' })}>
        <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
          <Stack spacing={1.5}>
            <Typography variant="subtitle2" fontWeight="bold" color="#e65100">
              Approval required
            </Typography>
            <Typography variant="body2">
              {approval.summary || approval.tool_name}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              This change will not run until you approve it. Expires{' '}
              {approval.expires_at
                ? new Date(approval.expires_at).toLocaleString()
                : 'soon'}
              .
            </Typography>
            <Stack direction="row" spacing={1.5}>
              <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={onApprove}
                disabled={loading}
              >
                {loading ? <CircularProgress size={16} /> : 'Approve'}
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={onDismiss}
                disabled={loading}
              >
                Dismiss
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AiApprovalCard;
